export enum languageEnum {
    Dutch = 1,
    English = 2,
    Polish = 3,
    German = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enum-files/languageEnum.ts